import { _isometry} from './store.isometry'
import { getFocus, setFocus } from 'state/jotai'
import { activeProject } from 'state/jotai'
import { fn3, fn4 } from 'utilities/utility.misc'
import { _lowerQualityIsometry } from './store.lowerQualityIsometry'

const low_iso = key => getFocus(_lowerQualityIsometry, key)

const iso   = key => getFocus(_isometry, key)
const iso_  = key => setFocus(_isometry, key)

export const getIsoData = (key, sub = false, alt = false) => {
  const { pin, pid } = activeProject(iso(key))
  
  return sub
    ? iso(key)?.[pin]?.[pid]?.[sub] ?? alt
    : iso(key)?.[pin]?.[pid] ?? alt
}

export const getLowIsoData = (key, sub = false, alt = false) => {
  const { pin, pid } = activeProject(low_iso(key))
  return sub
    ? low_iso(key)?.[pin]?.[pid]?.[sub] ?? alt
    :  low_iso(key)?.[pin]?.[pid] ?? alt
}

export const setIsoData = key => {
  const { pin, pid } = activeProject()
  const set = iso_(key)
  return update => set(a => fn3(a, pin, pid, update))
}
